var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-spinner"},[_c('FontAwesomeIcon',{staticClass:"app-spinner__icon",class:_vm.spinnerClasses,attrs:{"icon":_vm.spinnerIcon}}),_c('div',{staticClass:"app-spinner__slot"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }